import React from "react";
import styles from "./TabsComponent.module.scss";

interface TabsProps {
  tabItems: { name: string; slug: string; content: any }[];
  activeItem: string;
  onTabChange: (slug: string) => void;
  isTabAlignLeft?: boolean;
  wrapperSpacing?: string;
  rootClass?: string;
}

const TabsComponent: React.FC<TabsProps> = (props: TabsProps) => {
  const { tabItems, activeItem, onTabChange, isTabAlignLeft, wrapperSpacing, rootClass } = props;

  const currentTabContent = tabItems.find((item) => item.slug === activeItem)?.content;

  return (
    <section className={`${styles.root} ${rootClass}`}>
      <>
        {!!tabItems?.length && (
          <div
            className={`${styles.tabsWrapper} ${isTabAlignLeft ? styles.isTabAlignLeft : ""}`}
            style={{ margin: wrapperSpacing }}
          >
            {tabItems.map(({ slug, name }) => {
              const isActive = activeItem === slug;

              return (
                <button
                  type={"button"}
                  onClick={() => onTabChange(slug)}
                  key={slug}
                  className={`${styles.tab} ${isActive ? styles.active : ""} `}
                >
                  {name}
                </button>
              );
            })}
          </div>
        )}

        {/* Tab Content */}
        <div className={styles.tabContent}>{currentTabContent}</div>
      </>
    </section>
  );
};

export default TabsComponent;
